import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 153.46 114.46"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M125.26 114.46H0L91.81 0h61.65l-28.2 114.46z",
      style: {"fill":"#cf0a2c"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M106.09 46.67V22.03H84.97v24.64H60.33v21.12h24.62v24.65h21.13V67.79h24.66V46.67h-24.65z",
      style: {"fill":"#fff"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LZ-logo"}) } }